import { Component } from '@angular/core';
import { ConsumptionService } from '../../../services/consumption.service';
import { AuthenticationService } from '../../../../@core/services/authentication.service';
import { IUser } from '../../../../@core/models/model';
import { ActivatedRoute } from '@angular/router';
import { DatepickerComponent } from '../../../../@core/components/ui/datepicker/datepicker.component';
import { UserService } from '../../../services/user.service';
import { FormsModule } from '@angular/forms';
import { Location } from '@angular/common';
import { DataTableComponent } from '../../../../@shared/components/data-table/data-table.component';
import { TableColumn, TableConfig } from '../../../../@shared/models/table.models';
import { MultiSelectComponent } from '../../../../@core/components/ui/multi-select';
import { CONSUMPTION_TABLE_COLUMNS, CONSUMPTION_TABLE_CONFIG } from './consumption-table.config';


@Component({
  selector: 'app-consumption-details',
  standalone: true,
  imports: [DataTableComponent, DatepickerComponent, FormsModule, MultiSelectComponent],
  templateUrl: './consumption-details.component.html',
  styleUrl: './consumption-details.component.scss'
})
export class ConsumptionDetailsComponent {
  rangeDates: Date[] | null = null;
  maxDate: Date = new Date();
  selectedUsers: { name: string, value: string }[] = [];
  selectedUserIds: string[] = []
  allUsers: { name: string, value: string }[] = []
  currentUser: IUser | null | undefined
  organizationId: string | null | undefined
  userId: string | null | undefined

  constructor(private consumptionService: ConsumptionService, private authService: AuthenticationService, private route: ActivatedRoute, private userService: UserService, private location: Location) {
    this.currentUser = this.authService.currentUserSubject.value
    // queryParams 
    this.organizationId = this.route.snapshot.queryParams['organization']
    this.userId = this.route.snapshot.queryParams['user']
    this.selectedUserIds = this.userId ? [this.userId] : []
  }

  rowData: {
    date: string,
    totalTokens: number,
    cost: number,
    rowIndex?: number
  }[] = []

  loading = false
  consumptionColumns: TableColumn[] = [...CONSUMPTION_TABLE_COLUMNS]
  consumptionTableConfig: TableConfig = { ...CONSUMPTION_TABLE_CONFIG }

  ngOnInit() {
    this.getConsumptionDetails();
    this.getUsers();
  }

  getUsers() {
    this.userService.getUsers().subscribe(res => {
      this.allUsers = res.data.users.map((user: IUser) => {
        return {
          name: `${user.firstName} ${user.lastName}`,
          value: user._id
        }
      })
    })
  }

  getConsumptionDetails() {
    this.loading = true
    this.consumptionTableConfig = { ...this.consumptionTableConfig, loading: true };

    let filter: {
      organization?: string,
      user?: string[],
      dateRange?: {
        startDate: Date,
        endDate: Date
      },
      skip?: number,
      limit?: number
    } = {}
    if (this.selectedUserIds.length > 0) {
      filter['user'] = this.selectedUserIds
    }
    if (this.organizationId) {
      filter['organization'] = this.organizationId
    } else if (this.currentUser?.organization) {
      filter['organization'] = this.currentUser.organization as string
    }
    if (this.rangeDates && this.rangeDates[0] && this.rangeDates[1]) {
      filter['dateRange'] = {
        startDate: this.rangeDates[0],
        endDate: this.rangeDates[1]
      }
    }
    filter['skip'] = 0
    filter['limit'] = 10000

    this.consumptionService.getConsumptionDetails(filter).subscribe((res) => {
      if (res.success) {
        this.loading = false
        this.rowData = res.data.data.map((item: any, index: number) => ({
          ...item,
          rowIndex: index + 1
        }));
        this.consumptionTableConfig = { ...this.consumptionTableConfig, loading: false };
      }
    })
  }

  userChange() {
    this.getConsumptionDetails();
  }

  dateChange() {
    if (this.rangeDates && this.rangeDates[0] && this.rangeDates[1]) {
      this.getConsumptionDetails();
    } else if (!this.rangeDates || (!this.rangeDates[0] && !this.rangeDates[1])) {
      this.getConsumptionDetails();
    }
  }

  goBack() {
    this.location.back();
  }
}
